import { dehydrate, QueryClient, useQuery } from 'react-query'
import { getLegalDocs, getPostPage } from 'src/@shared/service/cms-api'
import { Blog } from 'src/@shared/types/cms/blog'
import BlogDetailPost from '@modules/blog/components/BlogDetailPost/BlogDetailPost'
import { Container } from 'react-bootstrap'

import CustomHead from '@atk/components/head/customHead/customHead'
import Newsletter2 from '@atk/components/newsletter/Newsletter2/Newsletter2'
import BlogHorizontal from '@atk/components/blog/BlogHorizontal/BlogHorizontal'

import FramerMotion from '@atk/hooks/framerMotion'

import { OpenGraphProps } from '../../@shared/components/head/customHead/customHead'

export type BlogDetailSSProps = {
    query: { slug: string }
}

const initialCatArgs = { sort: 'timeCreated', limit: 0, parent: 'Blog' }

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getServerSideProps({ query }: BlogDetailSSProps) {
    const queryClient = new QueryClient()
    // prefetch data on the server
    await Promise.all([
        queryClient.fetchQuery(['legaldocs'], () => getLegalDocs({ sort: 'position', limit: 0, page: 1 })),
        queryClient.fetchQuery(['blog-detail', query.slug], () => getPostPage({ slug: query.slug }, initialCatArgs)),
    ])
    return {
        props: {
            // dehydrate query cache
            dehydratedState: dehydrate(queryClient),
            slug: query.slug,
        },
    }
}

export default function BlogDetail({ slug }: { slug: string }) {
    const { data } = useQuery(['blog-detail', slug], () => getPostPage({ slug }, initialCatArgs))
    const detail = data as Blog
    const og: OpenGraphProps = {
        ogTitle: detail.meta.title,
        ogDescription: detail.meta.description ?? '',
        ogImage: detail.meta.imageUrl ?? detail.headerUrl,
    }
    const pageClass = `blogDetailPage`
    return (
        <div className={pageClass}>
            <CustomHead
                title={detail.meta.title}
                description={detail.meta.description ?? 'Content Description'}
                og={og}
            />
            <FramerMotion animation="fadeIn">
                <main>
                    {data && <BlogDetailPost post={data} />}
                    {data?.associationsData.blog && data?.associationsData.blog.length > 0 && (
                        <FramerMotion>
                            <section className="relatedPosts">
                                <Container>
                                    <h5>Related Post</h5>
                                    <BlogHorizontal
                                        list={data?.associationsData.blog}
                                        isLoading={false}
                                        hasNextPage={false}
                                        withoutFeatured={true}
                                        date
                                    />
                                </Container>
                            </section>
                        </FramerMotion>
                    )}
                    <FramerMotion>
                        <Newsletter2 col1={5} col2={7} title="Sign up for our newsletter!" />
                    </FramerMotion>
                </main>
            </FramerMotion>
        </div>
    )
}
